// extracted by mini-css-extract-plugin
export default {"main_100-vh-header":"style_main_100-vh-header__yfpqK"};